import "../scss/main.scss";

import { initCursor } from "./modules/cursor";
import { initHeroCanvas } from "./modules/hero-canvas";
import { initNav } from "./modules/nav";
import { initPopups } from "./modules/popup";
import { initReveal } from "./modules/reveal";
import { initTopoRail } from "./modules/topo-rail";

document.addEventListener("DOMContentLoaded", () => {
    initCursor();
    initHeroCanvas();
    initNav();
    initTopoRail();
    initReveal();
    initPopups();
});
